import {extractOptionFromElement} from "./options_parser";

export function getType(controller) {
  return controller.coupdoeilElement.dataset.popoverType
}

export function getParams(controller) {
  return controller.coupdoeilElement.dataset.popoverParams
}

export function getOptions(controller) {
  return controller.coupdoeilElement.dataset.popoverOptions
}

export function getTrigger(controller) {
  return extractOptionFromElement(controller.coupdoeilElement, 'trigger')
}

export function triggeredOnClick(controller) {
  return getTrigger(controller) === 'click'
}

export function noTriggeredOnClick(controller) {
  return getTrigger(controller) !== 'click'
}

export function triggeredOnHover(controller) {
  return getTrigger(controller) === 'hover'
}

export function notTriggeredOnHover(controller) {
  return getTrigger(controller) !== 'hover'
}

export function preloadedContentElement(controller) {
  return controller.coupdoeilElement.querySelector('.popover-content')
}
